import styles from './ProjectsGallery.module.scss'
import Project from './Project'

export default function ProjectsGallery({ projects }) {
  return (
    <div className={styles.grid}>
      {projects.map((p) => (
        <Project
          key={p.slug}
          title={p.title}
          slug={p.slug}
          heroImg={p.heroImg}
        />
      ))}
    </div>
  )
}
